import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSetAtom } from "jotai";
import { paymentTypeAtom } from "../../../../store/globalstore";
import "../../../../";
import crossBlack from "../../../../assets/images/onboardingImages/crossBlack.svg";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import "../../../VerifyTradePayment/verifyTradeInfo.css";
import ProfileIcon from "../../../../assets/images/Profile.svg";
import { useDispatch, useSelector } from "react-redux";
import { resetOnBoardingStartContext } from "../../../../redux/users/usersSlice";
import { useEffect, useState } from "react";
const ExchangeInfoModal = () => {
  const navigate = useNavigate();
  const community = useSelector(
    (value) => value?.user?.user.memberCommunities[0].community,
  );
  const [show, setshow] = useState(false);
  const setPaymentType = useSetAtom(paymentTypeAtom);
  const { user } = useSelector((state) => state.user);
  const onBoardingStartContext = useSelector(
    (state) => state.user?.onBoardingStartContext,
  );
  const dispatch = useDispatch();
  const isConnected =
    user?.binanceCredentials?.isConnected ||
    user?.bybitCredentials?.isConnected;

  const handleClose = () => {
    if (onBoardingStartContext) {
      navigate(onBoardingStartContext, { replace: true });
      dispatch(resetOnBoardingStartContext());
      return;
    }
    navigate("/member/dashboard", { replace: true });
  };
  useEffect(() => {
    if (user?.memberCommunities?.[0]?.subscribed) {
      navigate("/member/dashboard", { replace: true });
    } else {
      setshow(true);
    }
  }, []);
  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal verifyTrdeInfo"
        show={show}
      >
        <Modal.Body className="figma-drop-shadow verifyJoinTrade">

          <button className="CrossIcon" onClick={handleClose} type="button">
            <img alt="crossBlack" src={crossBlack} />
          </button>

          <div className="verifyTradeContent">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                marginBottom: "20px",
              }}
            >
              <div
                // className="onboardingCardTopBox"
                style={{
                  width: 35,
                  height: 35,
                  // background: "#2563EB",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                {community?.logo ? (
                  <img
                    src={community.logo}
                    alt={`${community?.disPlayName} logo`}
                    // className="communityLogo"
                    style={{
                      width: "35px",
                      height: "35px",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                ) : (
                  <img
                    src={ProfileIcon}
                    alt="community logo"
                    // className="communityLogo"
                    style={{
                      width: "35px",
                      height: "35px",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                )}
              </div>
              <span
                style={{
                  fontSize: 16,
                  fontWeight: 900,
                  letterSpacing: "0.06em",
                  textTransform: "uppercase",
                  color: "#000",
                  fontFamily:
                    "Graphik Bold, -apple-system, BlinkMacSystemFont, sans-serif",
                }}
              >
                {community?.disPlayName.toUpperCase()}
              </span>
            </div>
            <h2 className="title">2 Steps to join our copy trading </h2>

            <ul className="infoList">
              <li>
                <span className="checkmark">
                </span>
                1. Connect your exchange account via API to receive our buy/sell
                signals.
              </li>
              <li>
                <span className="checkmark">
                </span>
                2. Subscribe to our service with a 7-day free trial. Cancel
                anytime before it ends; otherwise, your subscription will
                continue. Payments are securely processed by Stripe.
              </li>
            </ul>
          </div>
          <div
            className="d-sm-flex justify-content-center align-items-center flex-column"
            style={{ gap: "20px" }}
          >
            <BubbleSvgButton
              className="NextBtn"
              onClick={() => {
                setPaymentType("onetime");
                navigate("/member/onboarding/connection", { replace: true });
              }}
              text={"Got it! Let's go"}
              type="button"
              variant="black"
              containerStyling={{
                justifyContent: "center",
              }}
              mainDivStyle={{
                width: "275px",
                height: "55px",
              }}
            />

          </div>
          <div className="paginationDots">
            <button className="dot active"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ExchangeInfoModal;
